import { rcTheme, Symbols } from '@hopin-team/ui-symbols';
import merge from 'lodash.merge';

export const mergeThemeValues = (
  brandColour: string | null,
  currentTheme: Symbols,
  theme?: any | null,
) => {
  const colour = brandColour || currentTheme.COLOR.BLUE.DEFAULT;

  const colourBranding = {
    COLOR: {
      THEME: {
        DEFAULT: colour,
        PRIMARY: colour,
        SECONDARY: colour,
        TERTIARY: colour,
      },
      GREY: {
        100: theme?.colorGray100 || currentTheme.COLOR.GREY[100],
        200: theme?.colorGray200 || currentTheme.COLOR.GREY[200],
        300: theme?.colorGray300 || currentTheme.COLOR.GREY[300],
        400: theme?.colorGray400 || currentTheme.COLOR.GREY[400],
        500: theme?.colorGray500 || currentTheme.COLOR.GREY[500],
        600: theme?.colorGray600 || currentTheme.COLOR.GREY[600],
        700: theme?.colorGray700 || currentTheme.COLOR.GREY[700],
        800: theme?.colorGray800 || currentTheme.COLOR.GREY[800],
        900: theme?.colorGray900 || currentTheme.COLOR.GREY[900],
        WHITE: theme?.colorWhite || currentTheme.COLOR.GREY.WHITE,
        BLACK: theme?.colorBlack || currentTheme.COLOR.GREY.BLACK,
        LIGHT: theme?.colorGray300 || currentTheme.COLOR.GREY.LIGHT,
        MEDIUM: theme?.colorGray650 || currentTheme.COLOR.GREY.MEDIUM,
        DARK: theme?.colorGray800 || currentTheme.COLOR.GREY.DARK,
      },
      UTILITY: {
        ACTION: colour,
        DEFAULT: colour,
      },
      PRIMARY: {
        100: theme?.colorPrimary100 || currentTheme.COLOR.BLUE[100],
        200: theme?.colorPrimary200 || currentTheme.COLOR.BLUE[200],
        300: theme?.colorPrimary300 || currentTheme.COLOR.BLUE[300],
        400: theme?.colorPrimary400 || currentTheme.COLOR.BLUE[400],
        500: theme?.colorPrimary500 || currentTheme.COLOR.BLUE[500],
        600: theme?.colorPrimary500 || currentTheme.COLOR.BLUE[600],
        700: theme?.colorPrimary500 || currentTheme.COLOR.BLUE[700],
        800: theme?.colorPrimary500 || currentTheme.COLOR.BLUE[800],
        900: theme?.colorPrimary500 || currentTheme.COLOR.BLUE[900],
      },
    },
    LINE: {
      ACCENT_BORDER: `0.125rem solid ${colour}`,
      ACTIVE_BORDER: `${currentTheme.LINE.WIDTH} solid ${colour}`,
      SELECTED_BORDER: `${currentTheme.LINE.WIDTH} solid ${
        colour || currentTheme.COLOR.BLUE[300]
      }`,
    },
  };

  return merge(rcTheme, colourBranding);
};
